import { reactive, readonly } from 'vue'

export interface ToastMessage {
  id: number
  title: string
  message?: string
  kind: 'success' | 'info' | 'error'
}

const state = reactive<{ current: ToastMessage | null }>({ current: null })
let nextId = 1
let timer: ReturnType<typeof setTimeout> | undefined

// One toast at a time, bottom-right, auto-dismissed (prototype behaviour). Rendered by <UiToastHost>.
export function useToast() {
  function show(title: string, message?: string, kind: ToastMessage['kind'] = 'success') {
    clearTimeout(timer)
    state.current = { id: nextId++, title, message, kind }
    timer = setTimeout(() => (state.current = null), kind === 'error' ? 7000 : 4200)
  }

  function dismiss() {
    clearTimeout(timer)
    state.current = null
  }

  return {
    state: readonly(state),
    success: (title: string, message?: string) => show(title, message, 'success'),
    info: (title: string, message?: string) => show(title, message, 'info'),
    error: (title: string, message?: string) => show(title, message, 'error'),
    dismiss,
  }
}
